import Home from "../components/home/home";
import { Route } from "../security/route";
import Parametre from "../components/Setting/parametre";
import AddSupport from "../components/Support/add-support/addSupport";
import CategoryDetails from "../components/category-details/categoryDetails";
import statistic from "../components/statistic/statistic";

export const routes: Route[] = [
  { path: "/", Component: Home, exact: true },
  { path: "/category/:layout/:layout", Component: CategoryDetails },
  { path: "/parametre", Component: Parametre, roles: ["ROLE_MEDIATHEQUE_ADMIN"] },
  { path: "/support/add/:layout", Component: AddSupport, roles: ["ROLE_MEDIATHEQUE_ADMIN"] },
  { path: "/statistic", Component: statistic, roles: ["ROLE_MEDIATHEQUE_ADMIN"] },
];
